/**
 * regionStatusConverters.js
 *
 * DashboardRegionStatusPage から抽出された純粋関数群
 * Region ステータス画面固有のデータ変換・進捗判定ロジックを提供
 */

/**
 * ステータス名と予定終了日から進捗ラベルを判定
 * @param {string} statusName - ステータス名（'完了', '進行中' など）
 * @param {string|null} endDatePlan - 予定終了日（YYYY-MM-DD形式）
 * @param {string} today - 基準日（YYYY-MM-DD形式）
 * @returns {'completed'|'unknown'|'delay'|'plan'} 進捗ラベル
 */
export function progressLabel(statusName, endDatePlan, today) {
  if (statusName === '完了') return 'completed';
  if (!endDatePlan) return 'unknown';
  if (endDatePlan < today) return 'delay';
  return 'plan';
}

/**
 * 複数の進捗ラベルをロールアップして統合判定
 * @param {Array<string>} labels - 進捗ラベル配列（'completed', 'delay', 'plan', 'unknown'）
 * @returns {'delay'|'completed'|'unknown'|'plan'} ロールアップ後のラベル
 */
export function rollupProgress(labels) {
  if (labels.length === 0) return 'unknown';
  if (labels.includes('delay')) return 'delay';
  if (labels.every((l) => l === 'completed')) return 'completed';
  if (labels.every((l) => l === 'unknown')) return 'unknown';
  return 'plan';
}

/**
 * アイテム配列に進行中かつ期限内の項目が存在するかチェック
 * @param {Array<Object>} items - 進捗スケジュールアイテム配列
 * @param {string} today - 基準日（YYYY-MM-DD形式）
 * @returns {boolean} 進行中アイテムが存在する場合 true
 */
export function hasInProgress(items, today) {
  return items.some(
    (m) => m.status_name === '進行中' && m.end_date_plan && m.end_date_plan >= today,
  );
}

/**
 * アイテム配列から最新の予定終了日を取得
 * @param {Array<Object>} items - 進捗スケジュールアイテム配列
 * @returns {string|null} 最新の予定終了日（YYYY-MM-DD形式）、日付がない場合は null
 */
export function latestDate(items) {
  const dates = items.map((m) => m.end_date_plan).filter(Boolean).sort();
  return dates.length > 0 ? dates[dates.length - 1] : null;
}
